import mixin from '@/mixin';
const { _getTimestamp } = mixin.methods;

export default {
    setTopicsModel: (state, topicsModel) => { state.topicsModel = topicsModel },

    setSubtopics: (state, subtopics) => { state.subtopics = subtopics },

    setClickedReferences: (state, clickedReferences) => { state.clickedReferences = clickedReferences },
    setItemContent: (state, itemContent) => { state.itemContent = itemContent },
    setTopicsNews: (state, topicsNews) => { state.topicsNews = topicsNews }
}